// ==============================|| PERMISSION KEYS (backend cityzen-be-v2) ||============================== //
// Cheile corespund exact atributelor [RequirePermission("...")] din controllerele backend.
// Centralizate aici ca să evităm typo-uri când le aplicăm pe rute / meniu.

export const P = {
	usersRead: 'users:read',
	usersWrite: 'users:write',
	usersDelete: 'users:delete',
	usersBlock: 'users:block',
	usersMute: 'users:mute',
	usersResetPassword: 'users:reset-password',
	usersLogs: 'users:logs',
	usersImport: 'users:import',
	usersManageRoles: 'users:manage-roles',

	rolesRead: 'roles:read',
	rolesWrite: 'roles:write',
	rolesDelete: 'roles:delete',
	rolesManagePermissions: 'roles:manage-permissions',
	permissionsRead: 'permissions:read',

	administrationsRead: 'administrations:read',
	administrationsWrite: 'administrations:write',
	administrationsDelete: 'administrations:delete',

	invitationsRead: 'invitations:read',
	invitationsWrite: 'invitations:write',

	projectsRead: 'projects:read',
	projectsWrite: 'projects:write',
	projectsDelete: 'projects:delete',

	// Cartiere — comunitățile administrate ale unei localități (modul propriu, separat de proiecte)
	neighborhoodsRead: 'neighborhoods:read',
	neighborhoodsWrite: 'neighborhoods:write',
	neighborhoodsDelete: 'neighborhoods:delete',

	// Nomenclatoare
	projectTypesRead: 'project_types:read',
	projectTypesWrite: 'project_types:write',
	projectTypesDelete: 'project_types:delete',
	// Stadii de proiect — BE expune doar cheia de scriere (nu există `:read`).
	projectStagesWrite: 'project_stages:write',
	projectStagesDelete: 'project_stages:delete',
	geometryStylesRead: 'geometry_styles:read',
	geometryStylesWrite: 'geometry_styles:write',
	geometryStylesDelete: 'geometry_styles:delete',
	// Tile-uri hartă — GET e public; BE expune write/delete (+ read în matricea nouă).
	mapTilesRead: 'map_tiles:read',
	mapTilesWrite: 'map_tiles:write',
	mapTilesDelete: 'map_tiles:delete',
	// Tipuri de anunț — BE expune doar cheia de scriere (nu există `:read`/`:delete`).
	announcementTypesWrite: 'announcement_types:write',
	// Județe / UAT-uri — nomenclatoare de referință read-only: BE expune doar `:read`
	// (toate rolurile îl au în seed; matricea permite revocarea per rol).
	countiesRead: 'counties:read',
	uatsRead: 'uats:read',

	announcementsRead: 'announcements:read',
	announcementsWrite: 'announcements:write',
	announcementsDelete: 'announcements:delete',

	surveysRead: 'surveys:read',
	surveysWrite: 'surveys:write',
	surveysDelete: 'surveys:delete',
	surveysExport: 'surveys:export',

	feedbacksRead: 'feedbacks:read',
	feedbacksWrite: 'feedbacks:write',
	feedbacksDelete: 'feedbacks:delete',

	assetsRead: 'assets:read',
	assetsWrite: 'assets:write',
	assetsDelete: 'assets:delete',

	agreementsRead: 'agreements:read',
	agreementsWrite: 'agreements:write',
	agreementsDelete: 'agreements:delete',

	// Gestionare texte (Traduceri) — pagina e gate-uită pe read; editarea pe write.
	translationsRead: 'translations:read',
	translationsWrite: 'translations:write',

	mobileReleasesRead: 'mobile_releases:read',
	mobileReleasesWrite: 'mobile_releases:write',
	mobileReleasesDelete: 'mobile_releases:delete',

	// Chat — acces la rută, gate-uit pe modulul unic „Chat" din BE. Permisiunile granulare sunt
	// per tip de cameră (chat_project / chat_administration / chat_group), vezi `chatPermission`.
	chat: 'chat',
	// Setări aplicație: pe BE managementul (GET-by-id / PUT) e gate-uit pe ROLUL Superadmin, NU pe o
	// permisiune RBAC. Cheia asta NU există în matricea BE → nimeni n-o are în set, deci doar Superadmin
	// trece (bypass-ul din hasPermission). Forward-compatible: dacă BE adaugă cândva permisiunea reală,
	// devine un gate real fără schimbări FE.
	settingsManage: 'settings:manage'
} as const;

export type ChatAction =
	| 'read'
	| 'write'
	| 'edit'
	| 'delete'
	| 'pin'
	| 'upload'
	| 'download'
	| 'attachmentsDelete'
	| 'moderate'
	| 'membersRead'
	| 'membersAdd'
	| 'membersRemove'
	| 'roomsWrite';

// roomTypeId (CHAT_ROOM_TYPE din src/types/chat.ts) → modulul BE corespunzător.
const CHAT_TYPE_MODULES: Record<number, string> = {
	1: 'chat_project',
	2: 'chat_administration',
	3: 'chat_group',
	4: 'chat_neighborhood'
};

const CHAT_ACTION_SUFFIX: Record<ChatAction, string> = {
	read: 'read',
	write: 'write',
	edit: 'edit',
	delete: 'delete',
	pin: 'pin',
	upload: 'upload',
	download: 'download',
	attachmentsDelete: 'attachments_delete',
	moderate: 'moderate',
	membersRead: 'members_read',
	membersAdd: 'members_add',
	membersRemove: 'members_remove',
	roomsWrite: 'rooms_write'
};

/** Cheia RBAC per tip de cameră (1=Proiect, 2=Administrație, 3=Grup) — oglinda ChatPermissions.KeyFor din BE. */
export const chatPermission = (roomTypeId: number, action: ChatAction): string =>
	`${CHAT_TYPE_MODULES[roomTypeId] ?? 'chat_project'}:${CHAT_ACTION_SUFFIX[action]}`;
